import React, { useState } from 'react';
import CloudStoragePage from './pages/CloudStoragePage';
import StorageCallbackPage from './pages/StorageCallbackPage';
import WelcomePage from './pages/WelcomePage';
import { isAuthenticated, clearAuth } from './services/authApi';

function usePathname() {
  const [path, setPath] = React.useState(window.location.pathname);
  React.useEffect(() => {
    const handler = () => setPath(window.location.pathname);
    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, []);
  return path;
}

export default function App() {
  const path = usePathname();
  const [authed, setAuthed] = useState(isAuthenticated());

  if (path === '/storage/callback' || path.startsWith('/storage/callback')) {
    return <StorageCallbackPage onAuth={() => setAuthed(true)} />;
  }

  if (!authed) {
    return <WelcomePage />;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '6px 16px', background: '#fff', borderBottom: '1px solid #e5e7eb' }}>
        <button
          onClick={() => { clearAuth(); setAuthed(false); }}
          style={{ background: 'none', border: '1px solid #d1d5db', borderRadius: 6, padding: '4px 12px', cursor: 'pointer', fontSize: 13, color: '#374151' }}
        >
          Sign out
        </button>
      </div>
      <CloudStoragePage />
    </div>
  );
}
